const colorVar = {
  hueGrey: 210,

  base: {
    h: 346,
    s: 100,
    l: 55,
  },

  prim: {
    h: 346,
    s: 100,
    l: 55,
  },

  sec: {
    h: 213,
    s: 51,
    l: 10,
  },
}

export const color = {
  font: `hsl(${colorVar.hueGrey}, 40%, 20%)`,
  heading: `hsl(${colorVar.hueGrey}, 40%, 20%)`,
  white: "rgba(255, 255, 255, 1)",
  whiteb: "rgba(255, 255, 255, 1)",
  body: "rgba(255, 255, 255, 1)",

  grey1: `hsl(${colorVar.hueGrey}, 20%, 10%)`,
  grey2: `hsl(${colorVar.hueGrey}, 10%, 20%)`,
  grey3: `hsl(${colorVar.hueGrey}, 10%, 30%)`,
  grey4: `hsl(${colorVar.hueGrey}, 10%, 40%)`,
  grey5: `hsl(${colorVar.hueGrey}, 15%, 50%)`,
  grey6: `hsl(${colorVar.hueGrey}, 15%, 65%)`,
  grey7: `hsl(${colorVar.hueGrey}, 15%, 80%)`,
  grey8: `hsl(${colorVar.hueGrey}, 20%, 90%)`,
  grey9: `hsl(${colorVar.hueGrey}, 25%, 95%)`,

  hue: "22",

  base1: `hsl(${colorVar.base.h}, ${colorVar.base.s}%, ${colorVar.base.l}%)`,
  base11: `hsl(${colorVar.base.h}, ${colorVar.base.s}%, ${colorVar.base.l}%)`,
  base2: `hsl(${colorVar.base.h}, ${colorVar.base.s}%, ${
    colorVar.base.l + 10
  }%)`,
  base3: `hsl(${colorVar.base.h}, ${colorVar.base.s}%, ${
    colorVar.base.l + 20
  }%)`,
  base4: `hsl(${colorVar.base.h}, ${colorVar.base.s}%, ${
    colorVar.base.l + 30
  }%)`,
  base5: `hsl(${colorVar.base.h}, ${colorVar.base.s}%, ${
    colorVar.base.l + 40
  }%)`,
  base6: `hsl(${colorVar.base.h}, ${colorVar.base.s}%, ${
    colorVar.base.l + 45
  }%)`,
  base7: `hsl(${colorVar.base.h}, ${colorVar.base.s}%, ${
    colorVar.base.l + 50
  }%)`,
  base8: `hsl(${colorVar.base.h}, ${colorVar.base.s}%, ${
    colorVar.base.l + 70
  }%)`,
  base9: `hsl(${colorVar.base.h}, ${colorVar.base.s}%, ${
    colorVar.base.l + 80
  }%)`,

  prim1: `hsl(${colorVar.prim.h}, ${colorVar.prim.s}%, ${colorVar.prim.l}%)`,
  prim2: `hsl(${colorVar.prim.h}, ${colorVar.prim.s}%, ${
    colorVar.prim.l + 10
  }%)`,
  prim3: `hsl(${colorVar.prim.h}, ${colorVar.prim.s}%, ${
    colorVar.prim.l + 20
  }%)`,
  prim4: `hsl(${colorVar.prim.h}, ${colorVar.prim.s}%, ${
    colorVar.prim.l + 30
  }%)`,
  prim5: `hsl(${colorVar.prim.h}, ${colorVar.prim.s}%, ${
    colorVar.prim.l + 40
  }%)`,
  prim6: `hsl(${colorVar.prim.h}, ${colorVar.prim.s}%, ${
    colorVar.prim.l + 50
  }%)`,
  prim7: `hsl(${colorVar.prim.h}, ${colorVar.prim.s}%, ${
    colorVar.prim.l + 60
  }%)`,
  prim8: `hsl(${colorVar.prim.h}, ${colorVar.prim.s}%, ${
    colorVar.prim.l + 70
  }%)`,
  prim9: `hsl(${colorVar.prim.h}, ${colorVar.prim.s}%, ${
    colorVar.prim.l + 80
  }%)`,

  sec1: `hsl(${colorVar.sec.h}, ${colorVar.sec.s}%, ${colorVar.sec.l}%)`,
  sec2: `hsl(${colorVar.sec.h}, ${colorVar.sec.s}%, ${colorVar.sec.l + 5}%)`,
  sec3: `hsl(${colorVar.sec.h}, ${colorVar.sec.s}%, ${colorVar.sec.l + 10}%)`,
  sec4: `hsl(${colorVar.sec.h}, ${colorVar.sec.s}%, ${colorVar.sec.l + 25}%)`,
  sec5: `hsl(${colorVar.sec.h}, ${colorVar.sec.s - 20}%, ${
    colorVar.sec.l + 30
  }%)`,
  sec6: `hsl(${colorVar.sec.h}, ${colorVar.sec.s}%, ${colorVar.sec.l + 35}%)`,
  sec7: `hsl(${colorVar.sec.h}, ${colorVar.sec.s}%, ${colorVar.sec.l + 40}%)`,
  sec8: `hsl(${colorVar.sec.h}, ${colorVar.sec.s}%, ${colorVar.sec.l + 45}%)`,
  sec9: `hsl(${colorVar.sec.h}, ${colorVar.sec.s}%, ${colorVar.sec.l + 50}%)`,

  opacityBlack06: "rgba(0, 0, 0, .6)",
}
